import {
  Calendar,
  Users,
  MessageSquare,
  BarChart,
  Settings,
  Shield,
} from 'lucide-react';
import { useTranslation } from '../hooks/useTranslation';

const FeatureCard = ({ icon: Icon, title, description }) => (
  <div className="p-6 rounded-lg border bg-card text-card-foreground shadow-sm hover:shadow-md transition-shadow">
    <div className="mb-4">
      <Icon className="w-10 h-10 text-[#00D1C7]" />
    </div>
    <h3 className="text-xl font-semibold mb-2">{title}</h3>
    <p className="text-muted-foreground">{description}</p>
  </div>
);

const Features = () => {
  const { t } = useTranslation();

  return (
    <section id="features" className="py-20 px-4 lg:px-8">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold mb-4">
            {t('featuresTitle')}
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            {t('featuresSubtitle')}
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          <FeatureCard
            icon={Calendar}
            title={t('uploadServices')}
            description={t('uploadServicesDesc')}
          />
          <FeatureCard
            icon={Users}
            title={t('patientHistory')}
            description={t('patientHistoryDesc')}
          />
          <FeatureCard
            icon={MessageSquare}
            title={t('patientComm')}
            description={t('patientCommDesc')}
          />
          <FeatureCard
            icon={BarChart}
            title={t('practiceAnalytics')}
            description={t('practiceAnalyticsDesc')}
          />
          <FeatureCard
            icon={Settings}
            title={t('brandCustomization')}
            description={t('brandCustomizationDesc')}
          />
          <FeatureCard
            icon={Shield}
            title={t('hipaaCompliantFeature')}
            description={t('hipaaCompliantFeatureDesc')}
          />
        </div>
      </div>
    </section>
  );
};

export default Features;
